import styled from "styled-components";

export const StateStats = styled.div`
  display: grid;
  gap: 1rem;
  width: 100%;

  /* Default layout: responsive grid */
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

  /* EBT Theft Page layout variant */
  &.ebt-theft-layout {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;

    /* First row: USD Theft card spanning full width */
    > *:nth-child(3) {
      grid-column: 1 / 3;
      grid-row: 1;
    }

    /* Second row: Current MAU card spanning full width */
    > *:nth-child(1) {
      grid-column: 1 / 3;
      grid-row: 2;
    }

    /* Third row: 2 cards */
    > *:nth-child(2) {
      grid-column: 1;
      grid-row: 3;
    }
    > *:nth-child(4) {
      grid-column: 2;
      grid-row: 3;
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(4, auto);

      > * {
        grid-column: 1 !important;
        grid-row: unset !important;
      }
    }
  }

  /* State Page 2 layout variant */
  &.state-page-2-layout {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;

    /* First row: USD Theft card (2nd card) spanning full width */
    > *:nth-child(2) {
      grid-column: 1 / 3;
      grid-row: 1;
    }

    /* Second row: 2 cards side by side */
    > *:nth-child(1) {
      grid-column: 1;
      grid-row: 2;
    }
    > *:nth-child(3) {
      grid-column: 2;
      grid-row: 2;
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(3, auto);

      > * {
        grid-column: 1 !important;
        grid-row: unset !important;
      }
    }
  }

  /* Propel Usage layout variant */
  &.propel-usage-layout {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;

    /* First row: MAU card (1st card) spanning full width */
    > *:nth-child(1) {
      grid-column: 1 / 3;
      grid-row: 1;
    }

    /* Second row: 2 cards side by side */
    > *:nth-child(2) {
      grid-column: 1;
      grid-row: 2;
    }
    > *:nth-child(3) {
      grid-column: 2;
      grid-row: 2;
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(3, auto);

      > * {
        grid-column: 1 !important;
        grid-row: unset !important;
      }
    }
  }
`;

export const StatCard = styled.div`
  background: #f8f9fa;
  padding: ${(props) => (props.$compact ? "2rem" : "1rem")};
  border-radius: 1rem;
  border: 2px solid #e9ecef;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${(props) => (props.$compact ? "140px" : "180px")};
`;

export const StatCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: ${(props) => (props.$compact ? "1rem" : "0.75rem")};
  height: ${(props) => (props.$compact ? "128px" : "100px")};
  text-align: center;
  padding-top: ${(props) => (props.$compact ? "0.25rem" : "0.5rem")};
`;

export const StatValue = styled.div`
  font-size: ${(props) => (props.size === "large" ? "3rem" : "2.5rem")};
  font-weight: bold;
  color: ${(props) => props.color || "inherit"};
`;

export const StatLabel = styled.div`
  font-size: ${(props) => (props.size === "large" ? "1.5rem" : "1.25rem")};
  font-weight: 600;
  color: #333;
  text-align: center;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatDescription = styled.div`
  color: #6c757d;
  text-align: center;
  font-size: 0.9rem;
`;

export const ComparisonText = styled.div`
  font-size: 1rem;
  text-align: center;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;

  &.positive {
    color: #16a34a; /* Green */
  }

  &.negative {
    color: #dc2626; /* Red */
  }

  &.neutral {
    color: #666;
  }
`;
